/**
 * Shared Web Audio context handle so play() can resume the graph
 * without importing the React hook (avoids a player ↔ sync cycle).
 */
let graphCtx: AudioContext | null = null;
let graphAttached = false;

export function setPlaybackAudioContext(ctx: AudioContext | null): void {
  graphCtx = ctx;
}

export function markWebAudioGraphAttached(): void {
  graphAttached = true;
}

export function isWebAudioGraphAttached(): boolean {
  return graphAttached;
}

export function ensureAudioContextRunning(
  ctx: Pick<AudioContext, "state" | "resume"> | null | undefined,
): void {
  if (!ctx || ctx.state !== "suspended") return;
  void ctx.resume().catch(() => undefined);
}

/** Resume the shared playback graph (call immediately before element.play()). */
export function resumePlaybackAudioContext(): void {
  ensureAudioContextRunning(graphCtx);
}
